//JS操作cookies方法!

//写cookies
const setCookie = (c_name: string, value: string, expiredays: number | null = null) => {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + (expiredays || 0))
  document.cookie = c_name + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())
}

//读取cookies
const getCookie = (name: string) => {
  let arr
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return arr[2]
  else return null
}

//删除cookies
const delCookie = (name: string) => {
  const exp = new Date()
  exp.setTime(exp.getTime() - 1)
  const cval = getCookie(name)
  if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString()
}
export { setCookie, getCookie, delCookie }
// //使用示例
// setCookie('username','Darren',30)
// alert(getCookie("username"));
